import moment from 'moment'
class activities {
  constructor(
      operId,
      from,
      to,
      mine,
      pendings,
      approved,
      reject,
      licens,
      schedules,
      hsExtra,
      licF,
      dele,
      columnas      
  ) {
 
      this.operId=operId
      this.from=moment(from).utc().format('YYYY-MM-DD')
      this.to=to == null ? null : moment(to).utc().format('YYYY-MM-DD') 
      this.mine=mine
      this.pendings=pendings
      this.approved=approved
      this.reject= reject
      this.licens=licens
      this.schedules=schedules
      this.hsExtra=hsExtra
      this.licF=licF
      this.dele=dele
      this.columnas = columnas
     
  }
  static fromJson({
      operId,
      fecDesde,
      fecHasta,
      mios,
      pendientes,
      aprobadas,
      rechazadas,
      licencias,
      cHorario,
      hsExtra,
      licF,
      dele,
      columnas
  }) {
    return new activities(
      operId,
      fecDesde,
      fecHasta,
      mios,
      pendientes,
      aprobadas,
      rechazadas,
      licencias,
      cHorario,
      hsExtra,
      licF,
      dele,
      columnas
    );
  }
}


export default activities;
